import { usePhotos } from "./usePhotos.web";

export const useOverviewMaps = (projectId: string, objectId: string) => {
  const [photos, isLoading] = usePhotos("overviewMaps", projectId, objectId);

  return [photos, isLoading] as const;
};
